export default "__VITE_ASSET__BeJBYop8__"